import { render, staticRenderFns } from "./GroupsShow.vue?vue&type=template&id=766121b8&scoped=true&"
import script from "./GroupsShow.vue?vue&type=script&lang=js&"
export * from "./GroupsShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766121b8",
  null
  
)

export default component.exports